import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { Props } from './ThanksModal.types';

export const renderThanksModal = (data?: Props) => {
    openPopupHelper({ popupName: popupNames.THANKS_MODAL, data, onClose: data?.onClose });
};
